import React, { useState } from "react";
import Layout from '../form-layout'

export default function Step12({ formData, setFormData, goToStep ,onBack}) {
  const [phone, setPhone] = useState(formData.phone || localStorage.getItem("phone") || "");
  const [email, setEmail] = useState(formData.email || localStorage.getItem("email") || "");
  const [errors, setErrors] = useState({});
  const [proceedClicked, setProceedClicked] = useState(false);

  const validateField = (field, value) => {
    let error = "";

    if (field === "phone") {
      const phoneRegex = /^[0-9]{10,15}$/;
      if (!value.trim()) error = "Phone number is required";
      else if (!phoneRegex.test(value.trim())) error = "Enter a valid phone number";
    }

    if (field === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value.trim()) error = "Email is required";
      else if (!emailRegex.test(value.trim())) error = "Enter a valid email address";
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
  };

  const handleProceed = (e) => {
    e.preventDefault();
    setProceedClicked(true);

    const phoneError =
      !phone.trim() || !/^[0-9]{10,15}$/.test(phone.trim())
        ? (!phone.trim() ? "Phone number is required" : "Enter a valid phone number")
        : "";

    const emailError =
      !email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
        ? (!email.trim() ? "Email is required" : "Enter a valid email address")
        : "";

    setErrors({ phone: phoneError, email: emailError });

    if (phoneError || emailError) return;

    localStorage.setItem("phone", phone.trim());
    localStorage.setItem("email", email.trim());

    setFormData((prev) => ({
      ...prev,
      phone: phone.trim(),
      email: email.trim(),
    }));

    goToStep("checkout");
  };

  return (
    <Layout title="" goToStep={goToStep} onBack={onBack}>
      <div className="flex justify-center items-center min-h-[80vh] px-4 bg-gradient-to-b from-[#f0f9ff] to-white">
        <div className="bg-white border border-sky-200 rounded-2xl shadow-md p-8 w-full max-w-md">
          <h2 className="text-xl font-bold text-slate-800 text-center mb-3">
            Contact Details
          </h2>

          <p className="text-gray-600 text-sm text-center mb-6 leading-relaxed">
            What are the best contact details to reach you for important updates and
            medical instructions?
          </p>

          <form onSubmit={handleProceed}>
            {/* Phone */}
            <div className="mb-4">
              <label className="block font-semibold mb-1 text-sm">Your best phone number:</label>
              <input
                type="text"
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                  setErrors((prev) => ({ ...prev, phone: "" }));
                }}
                className="w-full border-2 border-sky-500 rounded-lg px-3 py-2 text-sm outline-none"
              />
              {proceedClicked && errors.phone && (
                <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
              )}
            </div>

            {/* Email */}
            <div className="mb-4">
              <label className="block font-semibold mb-1 text-sm">Your best email:</label>
              <input
                type="text"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrors((prev) => ({ ...prev, email: "" }));
                }}
                className="w-full border-2 border-sky-500 rounded-lg px-3 py-2 text-sm outline-none"
              />
              {proceedClicked && errors.email && (
                <p className="text-red-500 text-xs mt-1">{errors.email}</p>
              )}
            </div>

            {/* Buttons */}
            <div className="flex justify-start gap-3 mt-6">
        

              <button
                type="submit"
                className="px-6 py-2 rounded-lg bg-sky-500 text-white font-semibold text-sm"
              >
                Proceed →
              </button>
            </div>
          </form>

          <p className="text-[11px] text-gray-500 mt-6 text-center leading-relaxed">
            Your privacy and security are our top priorities. We ensure your details remain
            confidential and will never be shared with third parties without your consent.
          </p>
        </div>
      </div>
    </Layout>
  );
}
